import { ChangeDetectionStrategy, Component, computed, effect, inject, Signal } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { FoundMedicationIncidentModel } from "../../services/found-medication-incident-model.service";
import { Location } from "@angular/common";
import { SharedModule } from "app/shared/shared.module";
import { FoundMedicationIncident, User } from "app/shared/types";
import { FoundMedicationIncidentSummaryComponent } from "../../components/found-medication-incident-summary/found-medication-incident-summary.component";
import { Store } from "@ngrx/store";

import { ContextService, MedicationActions } from "app/shared";

@Component({
	imports: [SharedModule, FoundMedicationIncidentSummaryComponent],
	providers: [FoundMedicationIncidentModel],
	selector: "ic-incident-summary",
	templateUrl: "./incident-summary.component.html",
	changeDetection: ChangeDetectionStrategy.OnPush,
	styleUrls: ["./incident-summary.component.scss"],
})
export class IncidentSummaryComponent {
	private readonly route = inject(ActivatedRoute);
	private readonly location = inject(Location);
	private readonly foundMedicationIncidentModel = inject(FoundMedicationIncidentModel);
	private readonly store = inject(Store);
	private readonly contextService = inject(ContextService);

	protected readonly medicationIncident = computed(() => this.getMedicationIncident());
	private readonly user: Signal<User> = computed(() => this.contextService.context().user);

	private getMedicationIncident(): FoundMedicationIncident {
		const foundMedicationIncidents = this.foundMedicationIncidentModel.foundMedicationIncidents();
		const { incidentId } = this.route.snapshot.params;

		// @ts-expect-error TS2322
		return foundMedicationIncidents.find((incident) => incident.id === incidentId);
	}

	protected goBack() {
		this.location.back();
	}

	constructor() {
		effect(async () => {
			if (this.medicationIncident().read === false) {
				await this.foundMedicationIncidentModel
					.createFoundMedicationIncidentUserReadConfirmation(this.medicationIncident().id, this.user().id)
					.toPromise()
					.then(() => {
						this.store.dispatch(
							MedicationActions.createFoundMedicationIncidentUserReadConfirmation({
								incidentId: this.medicationIncident().id,
							}),
						);
					});
			}
		});
	}
}
